module.exports = __webpack_public_path__ + "static/media/logo_branca_vermelha.0eb0a4ca.png";